import React, { useEffect, useState } from 'react';
import Styles from './table-styles.scss';
import { flexRender, functionalUpdate, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { SorterIcon } from '@/presentation/components';
import { ArrowSorterDown } from '../icons';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
function Table(props) {
    const { data = [], columns = [], columnsWithoutSort = [], pagination = {
        count: 0,
        page: 0,
        pageCount: 0,
        total: 0
    }, sort = {
        field: '',
        order: ''
    }, setAmountOfVideos, fetchData = () => null, filters = {}, loading = false, dataNotFound = false, DataNotFoundComponent, renderCellByType, tableHtmlId } = props;
    const [sorting, setSorting] = useState([]);
    const [pageCount, setPageCount] = useState(10);
    const [sortingAlter, setSortingAlter] = useState([]);
    const [{ pageIndex, pageSize }, setPagination] = useState({
        pageIndex: 1,
        pageSize: 10
    });
    const arrayFromColumns = columns.map(column => column.id);
    const customPagination = React.useMemo(() => ({
        pageIndex,
        pageSize
    }), [pageIndex, pageSize]);
    const table = useReactTable({
        data,
        columns,
        state: {
            sorting,
            pagination: customPagination
        },
        getCoreRowModel: getCoreRowModel(),
        // debugTable: true,
        manualPagination: true,
        onPaginationChange: setPagination,
        manualSorting: true,
        onSortingChange: updaterFunction => {
            const newValue = functionalUpdate(updaterFunction, sorting);
            console.log('NEW VALUEE', newValue);
            console.log('Columns', columns);
            const alterValue = newValue;
            if (alterValue.length > 0) {
                columns.map(column => {
                    console.log('column', column);
                    if (column.id === alterValue[0].id) {
                        if (column.field && column.field !== '') {
                            console.log('field', column.field);
                            alterValue[0].id = column.field;
                        }
                    }
                });
            }
            setSortingAlter(alterValue);
            setSorting(updaterFunction);
        }
    });
    const onSelect = (e) => {
        const { value } = e.target;
        if (setAmountOfVideos) {
            setAmountOfVideos(Number(value));
        }
        setPageCount(Number(value));
        fetchData({
            pageIndex: 1,
            pageSize: Number(value)
        });
    };
    useEffect(() => {
        if (sortingAlter && (sortingAlter === null || sortingAlter === void 0 ? void 0 : sortingAlter.length) > 0) {
            const sortingProps = sortingAlter[0];
            fetchData({
                pageIndex: 1,
                pageSize: pageCount
            }, {
                field: sortingProps === null || sortingProps === void 0 ? void 0 : sortingProps.id,
                order: (sortingProps === null || sortingProps === void 0 ? void 0 : sortingProps.desc) ? 0 : 1
            });
        }
    }, [sorting]);
    return (React.createElement("div", { className: Styles.tableWrap },
        !loading && dataNotFound && DataNotFoundComponent(),
        React.createElement("table", { id: tableHtmlId },
            !dataNotFound && (React.createElement("thead", null, table.getHeaderGroups().map(headerGroup => (React.createElement("tr", { key: headerGroup.id }, headerGroup.headers.map(header => {
                // const meta: any = header.column.columnDef.meta;
                var _a;
                return (React.createElement("th", { key: header.id, colSpan: header.colSpan, style: {
                        width: `${header.getSize()}%`
                    } }, header.isPlaceholder ? null : (React.createElement("div", { className: Styles.headerColumn, onClick: header.column.getToggleSortingHandler() },
                    flexRender(header.column.columnDef.header, header.getContext()),
                    columnsWithoutSort.includes(header.column.id) ? null : (React.createElement(SorterIcon, { direction: header.column.getIsSorted() && ((_a = sorting[0]) === null || _a === void 0 ? void 0 : _a.desc) ? 'desc' : 'asc' }))))));
            })))))),
            React.createElement("tbody", null,
                loading &&
                    arrayFromColumns.map(row => {
                        return (React.createElement("tr", { key: row },
                            React.createElement(SkeletonTheme, { baseColor: "rgba(242,244,248,0.8)", highlightColor: "rgba(227, 227, 228, 0.8)", borderRadius: "0.5rem", duration: 4 }, columns.map(column => (React.createElement("td", { key: column.id },
                                React.createElement(Skeleton, null)))))));
                    }),
                !loading &&
                    !dataNotFound &&
                    table.getRowModel().rows.map(row => {
                        var _a, _b;
                        return (React.createElement("tr", { key: row.id, id: `student_${(_b = (_a = row === null || row === void 0 ? void 0 : row.original) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : -1}` }, row.getVisibleCells().map(cell => {
                            return React.createElement("td", { key: cell.id }, renderCellByType(cell.getContext(), row.original));
                        })));
                    }))),
        React.createElement("div", { className: Styles.pagination },
            React.createElement("div", { className: Styles.show },
                React.createElement("span", null, "Show"),
                React.createElement("div", { className: Styles.select },
                    React.createElement("select", { onChange: onSelect },
                        React.createElement("option", { value: "10" }, "10"),
                        React.createElement("option", { value: "20" }, "20"),
                        React.createElement("option", { value: "50" }, "50"),
                        React.createElement("option", { value: pagination.total }, "All")),
                    React.createElement(ArrowSorterDown, { color: "#00A3FF" })),
                React.createElement("span", null, "entries")),
            React.createElement("div", { className: Styles.count },
                React.createElement("span", { className: Styles.pages },
                    pagination.page,
                    " - ",
                    pagination.pageCount),
                pagination.total && React.createElement("span", { className: Styles.total },
                    "/ ",
                    pagination.total),
                React.createElement("div", { className: Styles.buttons },
                    React.createElement("button", { onClick: () => {
                            fetchData({
                                pageIndex: pageIndex - 1,
                                pageSize: pageCount
                            });
                            table.previousPage();
                        }, disabled: pagination.page === 1, className: pagination.page === 1 ? Styles.disabled : '' }, '<'),
                    React.createElement("button", { onClick: () => {
                            fetchData({
                                pageIndex: pageIndex + 1,
                                pageSize: pageCount
                            });
                            table.nextPage();
                        }, disabled: pagination.page === pagination.pageCount, className: pagination.page === pagination.pageCount ? Styles.disabled : '' }, '>'))))));
}
export default Table;
